<template>
    <div>
        <buttonlist
                :newblock="false"
                :searchblock="true"
                :delblock="false"
                :reflashblock="true"
                :printblock="false"
                :impblock="false"
                :expsblock="false"
                :save="false"
                @search="search"
                @reflash="reflash"
        ></buttonlist>
        <el-table
                :data="dataSet"
                v-loading="loading"
                :highlight-current-row="true"
                show-overflow-tooltip="true"
                border
                stripe
                size="mini"
                :height="tableHeight"
                header-row-class-name="headerclass"
                style="width: 100%; margin-top:0px"
        >
            <el-table-column type="selection" v-if="false"></el-table-column>
            <el-table-column show-overflow-tooltip prop="GroupID" :label="$t('getapi[3204]')" width="200">
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="GroupName" :label="$t('getapi[3205]')" width="200">
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="" :label="$t('getapi[3206]')" width="200">
            </el-table-column>
            <el-table-column show-overflow-tooltip :label="$t('getapi[6048]')" width="60">
                <template slot-scope="scope">
                    <el-button @click.native.prevent="edit(scope.row)" type="text" size="small">{{$t('getapi[34]')}}</el-button>
                </template>
            </el-table-column>
        </el-table>

        <el-dialog v-dialogDrag :visible.sync="isVisible" width="50%">
            <el-row>
                <el-col :span="24">
                    <el-form :inline="true" :model="dataDetail" class="demo-form-inline" label-width="120px" label-position="left" size="small">
                        <el-row>
                            <el-col :span="12">
                                <el-form-item :label="$t('getapi[3204]')"><el-input v-model="dataDetail.GroupID"></el-input></el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item :label="$t('getapi[3205]')">
                                    <el-input v-model="dataDetail.GroupName"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item :label="$t('getapi[3206]')"><el-input ></el-input></el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                </el-col>

            </el-row>
            <span slot="footer" class="dialog-footer">
				<el-button @click="isVisible = false">{{$t('getapi[2054]')}}</el-button>
				<el-button type="primary" @click="save">{{$t('getapi[937]')}}</el-button>
			</span>
        </el-dialog>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';
    export default {
        name:'role',
        computed: {
            tableHeight(){
                return this.$windowSize.tableHeight-180
            }
        },
        data() {
            return {
                dataSet: [], // 主表数据
                isVisible: false, // 查询列表是否显示
                userData: [], // 用户信息
                DbTbNames: '',
                pageIndex: 1, // 当前页
                pageSize: 50, // 当前页数据量
                SelectIndexs: 1, //当前页面
                total: 0, // 数据总量
                loading: false, // 主表加载状态
                dataDetail:{},
            };
        },
        mounted: function () {
            let that = this;
            that.userData = JSON.parse(sessionStorage.getItem('userData'))
            that.user = that.userData.username
            that.getView()
        },
        methods: {
            // 数据一览
            getView() {
                let that = this;
                that.loading = true;
                let data = {

                };
                that.$http.urlpost('/Sys/Authority/GetRoleGroups', data, function (res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent;
                        that.loading = false;
                    }
                });
            },
            edit(row) {
                let that = this;
                that.isVisible = true
                let parm = {
                    Id: row.GroupID
                }
                that.$http.urlpost('/Sys/Authority/GetRoleGroupList', parm, function(res) {
                    if(res.Success == 1){
                        that.dataDetail = res.DataContent
                    }
                });
            }
        }
    };
</script>

<style scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }
    .el-form--inline .el-form-item {
        display: flex;
    }

    .tb-edit .el-input {
        display: none
    }

    .tb-edit .current-row .el-input {
        display: block;
    }

    .tb-edit .current-row .el-input + span {
        display: none
    }

    .el-table .hidden-row {
        display: none;
    }
</style>
